import React, { useEffect, useRef, useState } from 'react';
import { Send, Square, Wand2 } from 'lucide-react';

function Composer({ disabled, running, onSend, onStop, suggestions, draft, clearDraft, placeholder }) {
  const [text, setText] = useState('');
  const textarea = useRef(null);

  useEffect(() => {
    if (draft) {
      setText(draft);
      clearDraft?.();
      textarea.current?.focus();
    }
  }, [draft, clearDraft]);

  useEffect(() => {
    const element = textarea.current;
    if (!element) return;
    element.style.height = 'auto';
    element.style.height = `${Math.min(element.scrollHeight, 160)}px`;
  }, [text]);

  const submit = () => {
    const value = text.trim();
    if (!value || disabled || running) return;
    onSend(value);
    setText('');
  };

  return (
    <div className="dagent-composer">
      {suggestions?.length > 0 && (
        <div className="dagent-suggestions">
          {suggestions.map((suggestion) => (
            <button key={suggestion} type="button" className="dagent-suggestion" onClick={() => onSend(suggestion)} disabled={disabled || running}>
              <Wand2 size={12} aria-hidden="true" />
              {suggestion}
            </button>
          ))}
        </div>
      )}
      <div className="dagent-composer__box">
        <textarea
          ref={textarea}
          rows={1}
          value={text}
          disabled={disabled}
          placeholder={placeholder || 'Ask the agent to do something…'}
          onChange={(event) => setText(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' && !event.shiftKey && !event.nativeEvent.isComposing) {
              event.preventDefault();
              submit();
            }
          }}
          aria-label="Message the agent"
        />
        {running ? (
          <button type="button" className="dagent-icon-btn dagent-icon-btn--stop" onClick={onStop} title="Stop">
            <Square size={13} aria-hidden="true" />
          </button>
        ) : (
          <button type="button" className="dagent-icon-btn dagent-icon-btn--send" onClick={submit} disabled={disabled || !text.trim()} title="Send (Enter)">
            <Send size={15} aria-hidden="true" />
          </button>
        )}
      </div>
    </div>
  );
}

export default Composer;
